import React, { useState, useEffect } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
} from "@material-ui/core";
import utils from "../../utils/utils";
import Alert from "@material-ui/lab/Alert";
import CategoriesList from "../categories/CategoriesList";
import { HexColorPicker } from "react-colorful";
import "../categories/Categories.scss";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  paperFullWidth: {
    overflowY: "visible",
    maxWidth: 300,
  },
  dialogContentRoot: {
    overflowY: "visible",
  },
});

export default function Categories({ setIsLoading, setDataToast }) {
  let navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [dataTable, setDataTable] = useState();
  const classes = useStyles();
  const [companiesListCreate, setCompaniesListCreate] = useState([]);
  const [companiesList, setCompaniesList] = useState();
  const itemsPerPage = 10;
  const [filterData, setFilterData] = useState({
    companiesList: undefined,
    name: undefined,
  });
  const [paginationData, setPaginationData] = useState({
    count: 0,
    currentPage: 1,
  });
  const [createValues, setCreateValues] = useState({
    id: undefined,
    name: "",
    color: "#b32aa9",
    urlImage: "",
    companyId: "",
    externalCategory: "",
  });

  const shortError = (message) => {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  };

  const handleClickOpen = () => {
    setCreateValues({
      id: undefined,
      name: "",
      color: "",
      urlImage: "",
      companyId: "",
      externalCategory: "",
    });
    setOpen(true);
  };

  const handleImputChange = (e) => {
    setCreateValues({ ...createValues, name: e.target.value });
  };
  const handleImputChangeColor = (e) => {
    setCreateValues({ ...createValues, color: e });
  };
  const handleInputChangeCompanyId = (e) => {
    setCreateValues({ ...createValues, companyId: e.key });
  };
  const handleImputChangeExternalCategory = (e) => {
    setCreateValues({ ...createValues, externalCategory: e.target.value });
  };

  function uploadImage(e) {
    let files = e.target.files;
    if (files) {
      setIsLoading(true);

      let data = new FormData();
      let file = files.item(0);
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        data.append("files", files.item(0));

        api
          .uploadFile(data)
          .then((res) => {
            let file = res.data.files[0].url;
            setCreateValues({ ...createValues, urlImage: file });
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
            shortError("Ocurrió un error al subir el archivo.");
          });
      } else {
        setIsLoading(false);
        shortError("Solo se permite una imagen de formato JPG, JPEG o PNG.");
      }
    }
  }

  function setFilter(e) {
    let name = e.target.name;
    let value = e.target.value;
    setFilterData({ ...filterData, [name]: value });
  }

  function search(e) {
    e.preventDefault();
    reloadData(1, true);
  }

  function reloadData(page, reloadPages) {
    setIsLoading(true);
    let name = filterData.name;
    let companyId = filterData.companiesList;
    api
      .getCategories(page, 10, name, companyId)
      .then((res) => {
        let data = res.data;
        let currentPage = page;
        let count = paginationData.count;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          count = Math.ceil(data.cantidad / itemsPerPage);
        }

        setPaginationData({
          count: count,
          currentPage: currentPage,
        });
        let list = [];
        data.resultado.forEach((item) => {
          list.push({
            id: item.id,
            name: item.nombre,
            color: item.color,
            company: item.nombreCompania,
            imageUrl: item.imagenUrl,
            externalCategory: item.nombreCategoriaExterna,
          });
        });
        setDataTable(list);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error.");
      });
  }

  const checkValueCreateCategories = () => {
    let response = false;

    if (
      createValues.name.trim() &&
      createValues.color &&
      createValues.companyId &&
      createValues.urlImage &&
      createValues.externalCategory
    ) {
      response = true;
    }

    return response;
  };

  const onClickCreate = () => {
    if (checkValueCreateCategories()) {
      var body = {
        nombre: createValues.name.trim(),
        color: createValues.color,
        companiaId: parseInt(createValues.companyId),
        imagenUrl: createValues.urlImage,
        categoriaExterna: createValues.externalCategory.trim(),
      };

      api
        .postCreateCategory(body)
        .then(() => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Categoría creada correctamente.",
            type: "success",
          });

          reloadData(1, true);
          setOpen(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });
    } else if (!createValues.name.trim()) {
      shortError("Debe ingresar un Nombre");
    } else if (!createValues.color) {
      shortError("Debe ingresar un Color");
    } else if (!createValues.companyId) {
      shortError("Debe seleccionar una compañía");
    } else if (!createValues.urlImage) {
      shortError("Debe subir una imagen");
    } else if (!createValues.externalCategory) {
      shortError("Debe ingresar una categoría externa");
    }
  };

  useEffect(() => {
    setIsLoading(true);

    Promise.all([api.getCompanies()])
      .then((res) => {
        setCompaniesList(utils.setDataInSearchList(res[0].data));
        setCompaniesListCreate(utils.setDataInSearchList(res[0].data));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>CATEGORÍA</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={() => handleClickOpen()}
                >
                  Crear Nuevo
                </Button>

                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="form-dialog-title"
                  fullWidth={true}
                  classes={{
                    paperFullWidth: classes.paperFullWidth,
                  }}
                >
                  <DialogTitle id="form-dialog-title">
                    Nueva Categoría
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="name"
                      label="Nombre"
                      type="text"
                      name="nombre"
                      onChange={handleImputChange}
                      fullWidth
                    />
                  </DialogContent>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                  >
                    <section className="small example">
                      <HexColorPicker
                        color={createValues.color}
                        onChange={handleImputChangeColor}
                      />
                      <div
                        className="value"
                        style={{ borderLeftColor: createValues.color }}
                      >
                        Color:
                        {createValues.color != "#NaNNaNNaN"
                          ? " " + createValues.color
                          : ""}
                      </div>
                    </section>
                  </DialogContent>

                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300 }}
                  >
                    <ReactSelect
                      styles={{ maxWidth: 350 }}
                      placeholder="Asociar compañía..."
                      options={companiesListCreate}
                      onChange={handleInputChangeCompanyId}
                    />
                  </DialogContent>

                  <DialogContent>
                    {createValues.urlImage && (
                      <Alert severity="success">
                        Imagen subida{" "}
                        <a href={createValues.urlImage} target="_blank">
                          aqui.
                        </a>
                      </Alert>
                    )}
                    <input
                      accept="image/*"
                      className="c-none"
                      id="signature"
                      type="file"
                      accept="application/jpg"
                      onChange={uploadImage}
                    />
                    <label htmlFor="signature">
                      <Button
                        className="c-btn-info c-mb-5 c-mt-10"
                        variant="contained"
                        component="span"
                      >
                        Subir Imagen
                      </Button>
                    </label>
                  </DialogContent>
                  <DialogContent>
                    <TextField
                      margin="dense"
                      id="externalCategory"
                      label="Categoría Externa"
                      type="text"
                      name="categoriaExterna"
                      onChange={handleImputChangeExternalCategory}
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setOpen(false)}
                      className="c-btn-cancel"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={() => onClickCreate()}
                      className="c-btn-success"
                    >
                      Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>

              <Grid item xs={12}>
                <form onSubmit={search}>
                  <Grid container spacing={1}>
                    <Grid item md={3} xs={12}>
                      <TextField
                        fullWidth={true}
                        variant="outlined"
                        onChange={setFilter}
                        size="small"
                        name="name"
                        label="Nombre"
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl
                        variant="outlined"
                        fullWidth={true}
                        size="small"
                      >
                        <ReactSelect
                          placeholder="Buscar por compañías..."
                          name="companiesList"
                          onChange={(e) => {
                            setFilterData({
                              ...filterData,
                              companiesList: e ? e.value : undefined,
                            });
                          }}
                          options={companiesList}
                          isClearable={true}
                          required
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        className="c-btn-info c-mt-2"
                        variant="contained"
                        fullWidth={true}
                        type="submit"
                        startIcon={<SearchIcon />}
                        onClick={() => navigate("/categoria")}
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <CategoriesList
        setIsLoading={setIsLoading}
        setDataToast={setDataToast}
        dataTable={dataTable}
        classes={classes}
        setDataTable={setDataTable}
        shortError={shortError}
        reloadData={(page, reloadPage) => reloadData(page, reloadPage)}
        paginationData={paginationData}
      />
    </>
  );
}
